/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../src/jobiqo/config/jobs');
const R = require('ramda');
const { geoFixtures } = require('./fixtures');

module.exports = R.mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    GEO_INFO: {
      fixtures: geoFixtures,
      radius: {
        options: [5, 10, 30, 60, 100],
        defaultValue: 30,
        unit: 'miles',
        unitMultiplier: 1.6,
        hideForLocationType: ['country', 'administrative_area_level_1'],
      },
    },
    ALLOWED_JOB_TYPES: ['job_per_template'],
    JOB_ALERT: {
      MODAL: {
        APPLICABLE_JOB_APPLICATION_WORKFLOW: ['external'],
        FREQUENCY_DAYS: 10,
      },
      ignoreFields: ['notify_interval'],
      popup: {
        notifyIntervalValues: null,
      },
    },
    RECOMMENDER: {
      JOB_APPLICATIONS: true,
      JOB_APPLY_SUCCESS: true,
      MY_RECOMMENDATIONS_PAGE: true,
      JOB_DETAIL_PAGE_PUBLISHED: true,
      JOB_DETAIL_PAGE_EXPIRED: true,
    },
    ANALYTICS: {
      SOURCE_ENABLED: true,
    },
    AUTOSUGGESTIONS_ENABLED: true,
    AUTOSUGGESTIONS_AUTOFILL_FIELDS: [
      'field_job_occupational_field',
      'field_job_skills',
      'field_job_employment_type',
    ],
    JOB_PT_ATTACHMENT_ENABLED: true,
    JOB_SOLR_BACKFILL: true,
  },
});
